import {makeAutoObservable} from "mobx";

class UpdateModel {
	pending = false;

	constructor() {
		makeAutoObservable(this);
	}
}

export const updateModel = new UpdateModel();
